import React from 'react';
import PropTypes from 'prop-types';
import { Button, DialogContent, withStyles } from 'material-ui';
import PassengersCounterTabsStyle from './PassengersCounterTabsStyles';
import Tabs from './PassengersCounterTabs';

const PassengersTabsWrapper = ({
  selectedRoute,
  selectedTrip,
  flights,
  changePassengerNumber,
  open,
  handleClose,
  handleTabChange,
  selectedTab,
  classes,
}) => (
  <div
    style={{
      flex: 1,
      flexGrow: 1,
      padding: '0 !important',
      margin: '0 !important',
      width: '100%',
    }}
  >
    <Tabs
      selectedRoute={selectedRoute}
      selectedTrip={selectedTrip}
      flights={flights}
      selectedTab={selectedTab}
      handleTabChange={handleTabChange}
      changePassengerNumber={changePassengerNumber}
    />
    <DialogContent>
      <Button variant='raised' fullWidth color='primary' onClick={handleClose}>
        Done
      </Button>
    </DialogContent>
  </div>
);

PassengersTabsWrapper.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.object),
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  changePassengerNumber: PropTypes.func,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(PassengersCounterTabsStyle)(PassengersTabsWrapper);



// WEBPACK FOOTER //
// ./src/containers/flights/common/passengersCounter/PassengersCounterTabsWrapper.js